import React from 'react';
import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

export const MMTHeader = () => {
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)'
  });

  const [importedComponent, setImportedComponent] = useState(null);

  useEffect(() => {
    const importComponent = async () => {
      /* Dynamically load MMT-UI-Header component for Bigger Screen Size ONLY */
      const module = await import('pwa-mmt-ui-header/ssr/header');
      const MMTHeaderComponent = module.Header;
      setImportedComponent(<MMTHeaderComponent selectedTabName={'Cabs'} />);
    };

    !isMobileDevice && importComponent();
  }, [isMobileDevice]);

  return <>{importedComponent}</>;
};
